import { qcPointActionTypes } from '@Actions/quality/qcPointActions';

const QCPointReducers = (state = { }, action) => {
  switch (action.type) {
  case qcPointActionTypes.GET_QC_POINTS.LOADING: {
    const { qualityControlPointsLoading } = action;
    return {
      ...state,
      qualityControlPointsLoading,
    };
  }
  case qcPointActionTypes.GET_QC_POINTS.SUCCESS: {
    const { qualityControlPoints } = action;
    return {
      ...state,
      qualityControlPoints,
    };
  }
  case qcPointActionTypes.GET_QC_POINT_BY_ID.LOADING: {
    const { getQCPointByIdLoading } = action;
    return {
      ...state,
      getQCPointByIdLoading,
    };
  }
  case qcPointActionTypes.GET_QC_POINT_BY_ID.SUCCESS: {
    const { selectedQCPointById } = action;
    return {
      ...state,
      selectedQCPointById,
    };
  }
  case qcPointActionTypes.CREATE_QC_POINT.LOADING: {
    const { createQCPointLoading } = action;
    return {
      ...state,
      createQCPointLoading,
    };
  }
  case qcPointActionTypes.UPDATE_QC_POINT.LOADING: {
    const { updateQCPointLoading } = action;
    return {
      ...state,
      updateQCPointLoading,
    };
  }
  case qcPointActionTypes.UPDATE_QC_POINT_PRODUCT.LOADING: {
    const { updateQCPointProductLoading } = action;
    return {
      ...state,
      updateQCPointProductLoading,
    };
  }
  case qcPointActionTypes.DELETE_QC_POINT.LOADING: {
    const { deleteQCPointLoading } = action;
    return {
      ...state,
      deleteQCPointLoading,
    };
  }
  case qcPointActionTypes.DELETE_QC_POINT_GROUP.LOADING: {
    const { deleteQCPointGroupLoading } = action;
    return {
      ...state,
      deleteQCPointGroupLoading,
    };
  }
  case qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.LOADING: {
    const { getQCPointBySkuIdLoading } = action;
    return {
      ...state,
      getQCPointBySkuIdLoading,
    };
  }
  case qcPointActionTypes.GET_QC_POINT_BY_SKU_ID.SUCCESS: {
    const { qcPointsBySkuId } = action;
    return {
      ...state,
      qcPointsBySkuId,
    };
  }
  case qcPointActionTypes.DOWNLOAD_QC_POINTS.LOADING: {
    const { getQCPointsReportLoading } = action;
    return {
      ...state,
      getQCPointsReportLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default QCPointReducers;
